import * as React from 'react';
import { ReadOnlyContext, initialState } from './ReadOnlyContext';
import { jsx as _jsx } from "react/jsx-runtime";
const toggleAction = name => ({
  type: 'toggle',
  payload: name
});
const setAction = (name, readOnly) => ({
  type: 'set',
  payload: {
    name,
    readOnly
  }
});
const reducer = (state, action) => {
  switch (action.type) {
    case 'toggle':
      return {
        ...state,
        [String(action.payload)]: !state[action.payload]
      };
    case 'set':
      return {
        ...state,
        [String(action.payload.name)]: action.payload.readOnly
      };
    default:
      return state;
  }
};
const SectionReadOnlyProvider = ({
  children
}) => {
  const [sections, dispatch] = React.useReducer(reducer, initialState);
  const value = React.useMemo(() => ({
    sections,
    toggleReadOnly: name => dispatch(toggleAction(name)),
    setReadOnly: (name, readOnly) => dispatch(setAction(name, readOnly))
  }), [sections]);
  return /*#__PURE__*/_jsx(ReadOnlyContext.Provider, {
    value: value,
    children: children
  });
};
export default SectionReadOnlyProvider;